export const firebaseConfig = {
    apiKey: "AIzaSyC-E-Kg2sg4l6OEp4PSvsCuC8umWL_w6s8",
    authDomain: "av-info-dev.firebaseapp.com",
    databaseURL: "https://av-info-dev.firebaseio.com",
    projectId: "av-info-dev",
    storageBucket: "av-info-dev.appspot.com",
    messagingSenderId: "850092210716",
    appId: "1:850092210716:web:fb9d2dc6e47677601a3dd9",
    measurementId: "G-GRKJDHSZ18"
};